/**
 * Resolve caminhos de arquivos em /public para funcionar com base relativa (./) em produção.
 */
export function publicAssetUrl(path: string): string {
  const base = import.meta.env.BASE_URL || '/';
  const normalized = path.replace(/^\//, '');
  return `${base}${normalized}`;
}

export const WORKFLOW_ICON_URL = publicAssetUrl('assets/logo/workflow-icon.png');
